import DOMHelper from "../../../lib/dom-helper";
import CompaniesSlider from "../../../components/companies-slider";
import ReviewsSlider from "../../../components/reviews-slider";
import SectionVideo from "../../../components/base/section-video";
import LoadMore from "../../../components/base/load-more";
import PortfolioSection from "../../../components/portfolio-section";
import ModalForm from "../../../components/base/forms/modal-form";

export default class PageModule {
	constructor() {
		this.initHeroSection();
		this.initCompaniesSlider();
		this.initReviewsSlider();
		this.initLoadMoreSuccessStories();
		this.initPortfolioSection();
		this.initSuccessStoryForm();
		this.initVacancyForm();
	}

	initHeroSection() {
		this.heroSection = new SectionVideo({
			$root: document.getElementById('heroSectionVideo')
		});
	}

	initCompaniesSlider() {
		this.companiesSlider = new CompaniesSlider();
	}

	initReviewsSlider() {
		this.reviewsSlider = new ReviewsSlider();
	}

	initLoadMoreSuccessStories() {
		this.moreSuccessStories = new LoadMore({
			callback: () => {
				DOMHelper.tooltips();
				lozadObserver.observe();
			}
		});
	}

	initPortfolioSection() {
		this.portfolioSection = new PortfolioSection();
	}

	initSuccessStoryForm() {
		const id = 'success-story';
		const $trigger = document.querySelector(`[data-modal="${id}"]`);

		if ($trigger) {
			try	{
				this.consultationForm = new ModalForm({
					formId: id,
					uri: '/1.0/employment/success-story',
					$modalTriggers: [$trigger]
				});
			} catch (err) {
				console.error('Success Story Form:', err);
			}
		}
	}

	initVacancyForm() {
		const id = 'vacancy';
		const $trigger = document.querySelector(`[data-modal="${id}"]`);

		if ($trigger) {
			try	{
				this.consultationForm = new ModalForm({
					formId: id,
					uri: '/2.0/employment/vacancy',
					$modalTriggers: [$trigger]
				});
			} catch (err) {
				console.error('Vacancy Form:', err);
			}
		}
	}
}